import React from "react";
import { createPortal } from "react-dom";
import { HelpCircle, X } from "lucide-react";

const BondPlayInfoModal = ({
  open = false,
  onClose,
  title,
  subtitle,
  sections = [],
  titleId = "bplay-info-title",
  accent,
}) => {
  if (!open) return null;

  const rootClass = accent ? `bplay-info-root bplay-info-root--${accent}` : "bplay-info-root";

  return createPortal(
    <div className={rootClass} role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <button type="button" className="bplay-info-backdrop" aria-label="Close" onClick={onClose} />
      <div className="bplay-info-sheet">
        <header className="bplay-info-head">
          <div className="bplay-info-head-main">
            <span className="bplay-info-kicker">
              <HelpCircle size={12} strokeWidth={2.5} /> How it works
            </span>
            <h2 id={titleId} className="bplay-info-title">
              {title}
            </h2>
            {subtitle ? <p className="bplay-info-subtitle">{subtitle}</p> : null}
          </div>
          <button type="button" className="bplay-info-close" aria-label="Close" onClick={onClose}>
            <X size={16} strokeWidth={2.5} />
          </button>
        </header>

        <div className="bplay-info-body">
          {sections.map((section) => (
            <section key={section.title} className="bplay-info-section">
              <h3>{section.title}</h3>
              <ul>
                {section.items.map((item, index) => (
                  <li key={`${section.title}-${index}`}>{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <button type="button" className="bplay-info-done" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>,
    document.body
  );
};

export default BondPlayInfoModal;
